import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAIProfileByTask as fetchAIProfileByTaskApi } from '../Api/aiProfileApi';

const aiProfileSlice = createSlice({
    name: 'aiProfile',
    initialState: {
        profile: null,
        taskId: null,
        requestId: null,
        loading: false,
        error: null
    },
    reducers: {
        setAIProfile: (state, action) => {
            state.profile = action.payload;
            state.taskId = null;
        },
        updateAIProfile: (state, action) => {
            state.profile = action.payload;
            state.taskId = null;
        },
        clearAIProfile: (state) => {
            state.profile = null;
            state.taskId = null;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAIProfileByTaskAsync.pending, (state, action) => {
                state.requestId = action.meta.requestId;
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAIProfileByTaskAsync.fulfilled, (state, action) => {
                if (action.meta.requestId !== state.requestId) return;
                state.loading = false;
                state.profile = action.payload;
                state.taskId = action.meta.arg;
            })
            .addCase(fetchAIProfileByTaskAsync.rejected, (state, action) => {
                if (action.meta.requestId !== state.requestId) return;
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export const fetchAIProfileByTaskAsync = createAsyncThunk(
    'aiProfile/fetchAIProfileByTask',
    async (taskId) => {
        const response = await fetchAIProfileByTaskApi(taskId);
        return response;
    }
);

export const {
    setAIProfile,
    updateAIProfile,
    clearAIProfile,
    setLoading,
    setError
} = aiProfileSlice.actions;

// Selectors
export const selectAIProfile = (state) => state.aiProfile?.profile || null;
export const selectAIProfileTaskId = (state) => state.aiProfile?.taskId ?? null;
export const selectAIProfileLoading = (state) => state.aiProfile?.loading || false;
export const selectAIProfileError = (state) => state.aiProfile?.error || null;

export default aiProfileSlice.reducer;
